// Token storage abstraction.
// SECURITY NOTE: localStorage is vulnerable to XSS. This wrapper centralises the storage
// so we can migrate to httpOnly cookies (backend-issued) without touching the app code.
// When the backend supports Set-Cookie + credentials, replace the internals below.

const STORAGE_KEY = 'fdn_token';
const META_KEY = 'fdn_token_meta';
// 30 days (in ms) — mirrors backend JWT_EXPIRES_DAYS. Tokens older than that are dropped.
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const isDev = process.env.NODE_ENV === 'development';

function now() { return Date.now(); }

function warn(context, err) {
  if (isDev) console.warn(`[tokenStorage:${context}]`, err);
}

export const tokenStorage = {
  get() {
    try {
      const token = localStorage.getItem(STORAGE_KEY);
      if (!token) return null;
      const meta = JSON.parse(localStorage.getItem(META_KEY) || '{}');
      if (meta.savedAt && (now() - meta.savedAt) > MAX_AGE_MS) {
        this.clear();
        return null;
      }
      return token;
    } catch (e) {
      warn('get', e);
      return null;
    }
  },
  set(token) {
    try {
      localStorage.setItem(STORAGE_KEY, token);
      localStorage.setItem(META_KEY, JSON.stringify({ savedAt: now() }));
    } catch (e) {
      // Storage may be full or disabled (private browsing). Non-fatal — user just won't stay logged in.
      warn('set', e);
    }
  },
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(META_KEY);
    } catch (e) {
      warn('clear', e);
    }
  },
};
